<canvas baseChart [data]="chartData" [options]="chartOptions" [type]="type"></canvas>